@if (visible()) {
  <div class="user-interview-banner__wrapper">
    <div class="container">
      <div class="user-interview-banner">
        <div class="user-interview-banner__content">
          <div class="user-interview-banner__title">{{ "UserInterview.Banner.Title" | translate }}</div>
          <div class="user-interview-banner__text">{{ "UserInterview.Banner.Text" | translate }}</div>
        </div>
        <div class="user-interview-banner__action">
          <button class="button button--green" (click)="openModal()">
            {{ "UserInterview.Banner.Button" | translate }}
          </button>
          <button
            class="user-interview-banner__dismiss"
            (click)="dismiss()"
            [attr.aria-label]="'Global.Action.Close' | translate"
          >
            &times;
          </button>
        </div>
      </div>
    </div>
  </div>
}
